import { render } from "./Summary.vue?vue&type=template&id=0ecfac5e&scoped=true&ts=true"
import script from "./Summary.vue?vue&type=script&lang=ts"
export * from "./Summary.vue?vue&type=script&lang=ts"

import "./Summary.vue?vue&type=style&index=0&id=0ecfac5e&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecfac5e"]])

export default __exports__